import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import Button from '../Button';

import styles from './styles.scss';

function Modal({
  open, title, children, footer, onClose,
}) {
  return (
    <div
      className={classNames(styles.modalBackground, { [styles.open]: open })}
      onClick={stopPropagation}
      onKeyDown={stopPropagation}
      onKeyUp={stopPropagation}
      role="presentation"
    >
      <section className={styles.modal}>
        <header className={styles.header}>
          <h3 className={styles.title}>
            {title}
          </h3>
          {onClose && (
            <Button type="transparent" onClick={onClose}>
              &times;
            </Button>
          )}
        </header>
        <div className={styles.body}>
          {children}
        </div>
        {footer && (
          <footer className={styles.footer}>
            {footer}
          </footer>
        )}
      </section>
    </div>
  );
}

function stopPropagation(e) {
  e.stopPropagation();
}

Modal.propTypes = {
  open: PropTypes.bool,
  title: PropTypes.node,
  children: PropTypes.node,
  footer: PropTypes.node,
  onClose: PropTypes.func,
};

Modal.defaultProps = {
  open: null,
  title: null,
  children: null,
  footer: null,
  onClose: null,
};

export default Modal;



// WEBPACK FOOTER //
// ./src/app/components/Modal/index.js